import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import CustomButton from "../../components/CustomButton";
import ClassesList from "./ClassesList";
import { popupNavigation } from "../../util/functions/UniversalFunctions";
import AttendanceReportDropDown from "../../components/AttendanceReportDropdown";

export default function Classes() {
  const navigate = useNavigate();

  const menuItems = [
    {
      label: "Academic Year Wise",
      link: () => navigate(popupNavigation("yearlyReport")),
    },
    {
      label: "Month Wise",
      link: () => navigate(popupNavigation("monthlyReport")),
    },
    {
      label: "Date Wise",
      link: () => navigate(popupNavigation("byDate")),
    },
  ];

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-row justify-between  gap-5">
        <PageHeader />
        <div className="flex gap-2">
         <AttendanceReportDropDown menuItems={menuItems} />
          <CustomButton
            text="Add Class"
            color="bg-primary-500"
            onClick={() => navigate(popupNavigation("addClasses"))}
          />
        </div>
      </div>
      <ClassesList />
    </div>
  );
}
